import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { faWeightScale } from '@fortawesome/pro-solid-svg-icons/faWeightScale';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemWeightMeta() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	if (mailItemData?.itemSize?.weight === null || mailItemData?.itemSize?.weight === 0) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.weight')}
			content={`${mailItemData?.itemSize.weight && mailItemData.itemSize.weight !== 0 ? `${mailItemData.itemSize.weight / 1000}KG` : '0KG'}`}
			iconContent={{ icon: faWeightScale, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

export { MailItemWeightMeta };
